import { useState, useContext } from 'react'; 
import IconButton from '@mui/material/IconButton';
import InfoOutlineIcon from '@mui/icons-material/InfoOutlined';
import InfoIcon from '@mui/icons-material/Info';
import PageTooltip from './PageTooltip';
import PageContext from './PageContext';

const CustomInfoIcon = ({infoLabel}) => {
    // use context to get state vars from parent 
    const {
        setShowInfoModal, 
        setInfoModalLabel
    } = useContext(PageContext); 
    // to toggle between filled and empty icon
    const [hover, setHover] = useState(false); 
    // event handler for click 
    const onClick = () => {
        setInfoModalLabel(infoLabel); 
        setShowInfoModal(true); 
    }

    return (
        <PageTooltip title={'view'}>
            <IconButton
                onClick={onClick}
                // control over based on where mouse is 
                onMouseOver={() => setHover(true)}
                onMouseOut={() => setHover(false)}    
                // set color and hit area for hover
                sx={{
                    p: 0.1,               // tighter hit area than default
                    color: hover ? 'grey.600' : 'text.primary',
                    '&:hover': { color: 'text.primary' },
                }}
            >   
                {/* show Icon based on hover */}
                {hover ? <InfoIcon/> : <InfoOutlineIcon/>}
            </IconButton>
         </PageTooltip>
    ); 
}

export default CustomInfoIcon;